import { DIRECTIONS } from 'common/constants';
import styled from 'styled-components';

export const StyledTapWrapper = styled.div`
  ${({ theme }) => `
    background-color: ${theme.color.white};
    margin-top: ${theme.space[2]}px;
    & #error-handler {
      min-height: 20px;
      margin-inline-start: ${theme.space[5]}px;
      color: ${theme.color.danger};
    }
    & #privateTapElement {
      & iframe {
        max-height: 170px;
        min-height: 150px;
      }
    }
  `}
`;

export const StyledErrorWrapper = styled.div`
  padding: ${({ theme }) => theme.direction === DIRECTIONS.RIGHT_TO_LEFT ? 
  `${theme.space[2]}px ${theme.space[14]}px ${theme.space[2]}px`
  :`${theme.space[2]}px ${theme.space[2]}px ${theme.space[2]}px ${theme.space[14]}px`};
`;
